<template>
  <div id="app" class="h-full">
    <div class="h-full w-full overflow-y-auto">
      <router-view />
    </div>
    <GlobalAlert />
    <ToastContainer ref="toast" />
    <ProfileDrawer ref="profileDrawerRef" />
    <UserProfileDrawer ref="userProfileDrawerRef" />
    <NotificationsDrawer ref="notificationsDrawerRef" />
  </div>
</template>

<script>
import { DefaultLayout } from "@/widgets/app-layout";

// import { getLocaleById } from "@/shared/config/i18n";
import GlobalAlert from "@/shared/ui/custom/alert/GlobalAlert.vue";
import ToastContainer from "@/shared/ui/toast/ToastContainer.vue";
import { ProfileDrawer } from "@/widgets/profile-drawer";
import { UserProfileDrawer } from "@/widgets/user-profile-drawer";
import { NotificationsDrawer } from "@/widgets/notifications-drawer";
import moment from "moment";
moment.locale("ru");

export default {
  name: "App",
  components: {
    DefaultLayout,
    GlobalAlert,
    ToastContainer,
    ProfileDrawer,
    UserProfileDrawer,
    NotificationsDrawer,
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  mounted() {
    console.log("Component mounted.");
  },
};
</script>

<style lang="scss">
html,
body {
  min-height: 100%;
  height: 100%;
}
#app {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif;
  height: 100%;
}

.island-drawer {
  height: calc(100% - 20px) !important;
  top: 10px !important;
  right: 10px !important;
  @apply overflow-hidden rounded-md;
}
</style>
<script setup>
import { computed, watch, onBeforeUnmount, ref, provide } from "vue";
import { useStore } from "vuex";
import { centrifugeManager, fetcherEvents } from "@/shared/lib/centrifuge";
import {
  PROFILE_DRAWER_KEY,
  useNotaryHeartbeat,
} from "@/widgets/profile-drawer";
import { USER_PROFILE_DRAWER_KEY } from "@/widgets/user-profile-drawer";
import { NOTIFICATIONS_DRAWER_KEY } from "@/widgets/notifications-drawer";
import { useNotificationsRealtime } from "@/features/notifications-panel";
import { useNotificationStore } from "@/entities/notification";

const profileDrawerRef = ref(null);
const userProfileDrawerRef = ref(null);
const notificationsDrawerRef = ref(null);

provide(PROFILE_DRAWER_KEY, {
  open: (userId, opts) => profileDrawerRef.value?.open(userId, opts),
  openCreate: (opts) => profileDrawerRef.value?.openCreate(opts),
  openEdit: (userId, opts) => profileDrawerRef.value?.openEdit(userId, opts),
  openView: (userId, opts) => profileDrawerRef.value?.openView(userId, opts),
  close: () => profileDrawerRef.value?.close(),
});

provide(USER_PROFILE_DRAWER_KEY, {
  open: (uuid, opts) => userProfileDrawerRef.value?.open(uuid, opts),
  openCreate: (opts) => userProfileDrawerRef.value?.openCreate(opts),
  openEdit: (uuid, opts) => userProfileDrawerRef.value?.openEdit(uuid, opts),
  openView: (uuid, opts) => userProfileDrawerRef.value?.openView(uuid, opts),
  close: () => userProfileDrawerRef.value?.close(),
});

provide(NOTIFICATIONS_DRAWER_KEY, {
  open: () => notificationsDrawerRef.value?.open(),
  close: () => notificationsDrawerRef.value?.close(),
});

useNotaryHeartbeat();

const store = useStore();
const userUuid = computed(() => store.getters.get_self_user?.uuid);

const notificationStore = useNotificationStore();

let unsubscribeFetcher = null;
let stopNotificationsRealtime = null;

function connectFetcher(uuid) {
  if (!uuid || unsubscribeFetcher) return;
  centrifugeManager.init();
  unsubscribeFetcher = centrifugeManager.subscribe(
    `events/FETCHER/${uuid}`,
    (data) => fetcherEvents.emit(data)
  );
}

watch(
  userUuid,
  (uuid, prev) => {
    if (prev && prev !== uuid && unsubscribeFetcher) {
      unsubscribeFetcher();
      unsubscribeFetcher = null;
    }
    if (prev && prev !== uuid && stopNotificationsRealtime) {
      stopNotificationsRealtime();
      stopNotificationsRealtime = null;
      notificationStore.reset();
    }
    if (uuid) {
      connectFetcher(uuid);
      if (!stopNotificationsRealtime) {
        stopNotificationsRealtime = useNotificationsRealtime({
          userUuid: uuid,
        });
      }
    }
  },
  { immediate: true }
);

onBeforeUnmount(() => {
  if (unsubscribeFetcher) {
    unsubscribeFetcher();
    unsubscribeFetcher = null;
  }
  if (stopNotificationsRealtime) {
    stopNotificationsRealtime();
    stopNotificationsRealtime = null;
  }
  centrifugeManager.disconnect();
});
</script>
